import crypto from 'crypto';
import { parseMultibase } from '../../lib';
import { VerificationType, CryptoSuite } from '../../lib/types';
import { generateBls12381KeyPair } from './bls12381';
import { generateBbs2023KeyPair } from './bbs2023';
import { generateEcdsaSd2023KeyPair } from './ecdsaSd2023';

var __defProp = Object.defineProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: true });
const generateModernCryptosuite = /* @__PURE__ */ __name(async (type, keyPairOptions) => {
  switch (type) {
    case CryptoSuite.Bbs2023:
      return await generateBbs2023KeyPair(keyPairOptions);
    case CryptoSuite.EcdsaSd2023:
      return await generateEcdsaSd2023KeyPair();
    default:
      throw new Error(`Unsupported modern cryptosuite: ${type}`);
  }
}, "generateModernCryptosuite");
const generateKeyPair = /* @__PURE__ */ __name(async (keyPairOptions) => {
  const { type, seedBase58, privateKeyBase58, publicKeyBase58 } = keyPairOptions;
  if (!type) {
    throw new Error("Invalid key pair type");
  }
  let seed;
  const seedSupportedTypes = [
    VerificationType.Bls12381G2Key2020,
    CryptoSuite.Bbs2023
  ];
  if (seedSupportedTypes.includes(type)) {
    if (seedBase58) {
      seed = await parseMultibase("z" + seedBase58);
    }
    keyPairOptions.seed = seed ?? Uint8Array.from(crypto.randomBytes(32));
  }
  let generatedKeyPair;
  if (Object.values(CryptoSuite).includes(type)) {
    generatedKeyPair = await generateModernCryptosuite(type, keyPairOptions);
  } else {
    switch (type) {
      case VerificationType.Ed25519VerificationKey2018:
        throw new Error("Unsupported key pair type");
      case VerificationType.Bls12381G2Key2020:
        generatedKeyPair = await generateBls12381KeyPair(keyPairOptions);
        break;
      default:
        throw new Error("Unsupported key pair type");
    }
  }
  if (seedBase58 && type === VerificationType.Bls12381G2Key2020) {
    generatedKeyPair = generatedKeyPair;
    if (privateKeyBase58 && privateKeyBase58 !== generatedKeyPair.privateKeyBase58) {
      throw new Error("Private key does not match");
    }
    if (publicKeyBase58 && publicKeyBase58 !== generatedKeyPair.publicKeyBase58) {
      throw new Error("Public key does not match");
    }
  }
  return generatedKeyPair;
}, "generateKeyPair");

export { generateKeyPair };
